/* eslint-disable no-unused-vars */

window.jfp = (typeof window.jfp !== "undefined") ? window.jfp : {
    urlParams: new URLSearchParams(window.location.search),

    initialized: false,
    token: "",
    visitorId: 0,
    visitorSiteNavigationLogId: 0,
    eventQueue: [],

    publisherComponents: {
        loaded: [],
        viewed: []
    },

    init(token) {
        if(this.initialized) return;
        this.initialized = true;

        if(!token) {
            throw "Invalid token. Pixel not initialized.";
        }

        this.token = token;
        this.initVisitor();
        this.attachPublisherComponentViewedListeners();
    },

    initVisitor() {
        this.setVisitorId()
          .then(() => (new Promise((resolve) => { this.visitorSiteNavigationLogId = window.sessionStorage.getItem("jf-visitor-" + this.visitorId + "-site-navigation-log-id") ?? 0; resolve(); })))
          .then(() => this.logVisitorPage())
          .then(() => this.clearEventQueue());

        // If not logged in past X time period...
        // this.logVisitorGeolocation();
    },
    setVisitorId() {
        return new Promise((resolve) => {
            if(!this.getCookie("jfpc-visitor-id")) {
                if(window.localStorage.getItem("jfpc-visitor-id")) {
                    this.visitorId = window.localStorage.getItem("jfpc-visitor-id");
                    this.setCookie("jfpc-visitor-id", this.visitorId);
                }
            }
            else {
                this.visitorId = this.getCookie("jfpc-visitor-id");
                window.localStorage.setItem("jfpc-visitor-id", this.visitorId);
            }

            if(this.visitorId !== 0) {
                resolve();
            }
            else {
                (async () => {
                    const rawResponse = await fetch("https://api-v2.jumpfeed.com/network/publisher/visitor", {
                        method: "POST",
                        headers: { 'Authorization': "Bearer " + this.token },
                        body: new FormData()
                    });
                    const response = await rawResponse.json();
                    if(response.data.id) {
                        this.visitorId = response.data.id;
                        this.setCookie("jfpc-visitor-id", this.visitorId);
                        window.localStorage.setItem("jfpc-visitor-id", this.visitorId);
                        resolve();
                    }
                })();
            }
        });
    },
    /*logVisitorGeolocation() {
        (async () => {
            const rawResponse = await fetch("https://d33ok5lwvgxemb.cloudfront.net/");
            // end request timer
            let encryptedGeo = rawResponse.headers.get("viewer-geolocation");
            // log geo location data and return user zip code, set zip code localstorage
        })();
    },*/
    logVisitorPage() {
        return new Promise((resolve) => {
            if(this.visitorSiteNavigationLogId !== 0 && window.sessionStorage.getItem("jf-visitor-" + this.visitorId + "-session-last-logged-page") && window.sessionStorage.getItem("jf-visitor-" + this.visitorId + "-session-last-logged-page") === window.location.href) {
                resolve();
            }
            else {
                (async () => {
                    const rawResponse = await fetch("https://api-v2.jumpfeed.com/network/publisher/visitor/navigation", {
                        method: "POST",
                        headers: {
                            'Authorization': "Bearer " + this.token,
                            'Accept': "application/json, text/plain, */*",
                            'Content-Type': "application/json"
                        },
                        body: JSON.stringify(
                          {
                              visitor_id: this.visitorId,
                              url: window.location.href,
                              session: window.sessionStorage.getItem("jf-visitor-" + this.visitorId + "-session") ? window.sessionStorage.getItem("jf-visitor-" + this.visitorId + "-session") : 0
                          }
                        )
                    });
                    const response = await rawResponse.json();
                    if(typeof response.data.visitor_site_navigation_log_id !== "undefined") {
                        this.visitorSiteNavigationLogId = response.data.visitor_site_navigation_log_id;
                        window.sessionStorage.setItem("jf-visitor-" + this.visitorId + "-site-navigation-log-id", response.data.visitor_site_navigation_log_id);
                    }
                    if(typeof response.data.session !== "undefined") {
                        window.sessionStorage.setItem("jf-visitor-" + this.visitorId + "-session", response.data.session);
                        window.sessionStorage.setItem("jf-visitor-" + this.visitorId + "-session-last-logged-page", window.location.href);
                    }
                    resolve();
                })();
            }
        });
    },

    attachPublisherComponentViewedListeners() {
        // Searches for any newly loaded components in a "cool-down" manner, for up to 30 seconds, and attaches/handles event listeners that are triggered when the component element is inside the viewport.
        let loops = 0;
        let handleNewlyLoadedPublisherComponentElementsSearch = () => {
            let newPublisherComponentElements = this.searchForNewlyLoadedPublisherComponentElements();
            newPublisherComponentElements.forEach(newPublisherComponentElement => {
                if(this.isElementInViewport(newPublisherComponentElement)) {
                    this.handlePublisherComponentViewed(this.getLocalPublisherComponentIdentifier(newPublisherComponentElement.getAttribute("publisher-component-id"), newPublisherComponentElement.getAttribute("publisher-component-placement")));
                }
                else {
                    let viewedHandler = this.onElementInViewport(newPublisherComponentElement, () => {
                        if(window.removeEventListener && viewedHandler) {
                            window.removeEventListener('DOMContentLoaded', viewedHandler, false);
                            window.removeEventListener('load', viewedHandler, false);
                            window.removeEventListener('scroll', viewedHandler, false);
                            window.removeEventListener('resize', viewedHandler, false);
                        }
                        if (resizeObserver) resizeObserver.unobserve(newPublisherComponentElement);
                        this.handlePublisherComponentViewed(this.getLocalPublisherComponentIdentifier(newPublisherComponentElement.getAttribute("publisher-component-id"), newPublisherComponentElement.getAttribute("publisher-component-placement")));
                    });

                    let resizeObserver = new ResizeObserver(viewedHandler);
                    resizeObserver.observe(newPublisherComponentElement);

                    if (window.addEventListener) {
                        window.addEventListener('DOMContentLoaded', viewedHandler, false);
                        window.addEventListener('load', viewedHandler, false);
                        window.addEventListener('scroll', viewedHandler, false);
                        window.addEventListener('resize', viewedHandler, false);
                    }
                }
            });

            ++loops;
            if(loops < 10) {
                setTimeout(handleNewlyLoadedPublisherComponentElementsSearch, 100); // 1 sec
            } else if(loops < 18) {
                setTimeout(handleNewlyLoadedPublisherComponentElementsSearch, 250); // 3 sec
            } else if(loops < 24) {
                setTimeout(handleNewlyLoadedPublisherComponentElementsSearch, 500); // 6 sec
            } else if(loops < 28) {
                setTimeout(handleNewlyLoadedPublisherComponentElementsSearch, 1000); // 10 sec
            } else if(loops < 38) {
                setTimeout(handleNewlyLoadedPublisherComponentElementsSearch, 2000); // 30 sec
            }
        };

        setTimeout(handleNewlyLoadedPublisherComponentElementsSearch, 10);
    },
    handlePublisherComponentViewed(localPublisherComponentIdentifier) {
        if(!this.publisherComponents.viewed.includes(localPublisherComponentIdentifier)) {
            this.publisherComponents.viewed.push(localPublisherComponentIdentifier);
            this.clearEventQueue();
        }
    },
    searchForNewlyLoadedPublisherComponentElements() {
        // TODO: Any way to lookup the loaded components dynamically?
        // Each component will need to start with a common identifier ("jfpc-")
        /* let loadedComponents = document.evaluate( "//*[starts-with(name(),'jfpc-')]", document, null, XPathResult.ANY_TYPE, null );
        let loadedComponent = null;
        while((loadedComponent = loadedComponents.iterateNext())) {
           
        } */

        let eligible = [
            "jfpc-ads-modal-standard",
            "jfpc-ads-modal-autoweb-bodytype-fallback",
            "jfpc-ads-standard",
            "jfpc-ad-sense-ads-modal",
            "jfpc-call-button-quinstreet",
            "jfpc-external-ad-unit-autoweb",
            "jfpc-external-ad-unit-quinstreet",
            "jfpc-external-ad-unit-media-alpha",
            "jfpc-job-ads-modal-pool",
            "jfpc-job-ads-standard",
            "jfpc-job-listings-standard-custom",
            "jfpc-job-listing-featured-modal",
            "jfpc-job-listing-redirect",
            "jfpc-job-ads-postal-hiring-redirect-pool",
            "jfpc-make-model-keyword-search-ads-medianet-lander",
            "jfpc-make-model-keyword-search-ads-medianet-lander-modal",
            "jfpc-vehicle-listings-standard",
            "jfpc-vehicle-listings-standard-with-provider",
            "jfpc-vehicle-listings-standard-carfaxr",
            "jfpc-vehicle-listings-condensed",
            "jfpc-vehicle-listings-stacked",
            "jfpc-vehicle-listings-custom",
            "jfpc-vehicle-listings-ads-modal-custom",
            "jfpc-vehicle-details-page",
            "jfpc-vehicle-details-page-anonymous",
            "jfpc-vehicle-details-page-carfax",
            "jfpc-vehicle-lead-form",
            "jfpc-vehicle-listings-medianet-lander",
            "jfpc-vehicle-listings-most-clicked",
            "jfpc-vehicle-listings-most-viewed",
            "jfpc-vehicle-listings-newly-added",
            "jfpc-vehicle-listings-pricing-leaderboard",
            "jfpc-vehicle-listings-recent-price-drops",
            "jfpc-vehicle-listings-visitor-ai-recommended",
            "jfpc-vehicle-listings-visitor-ai-custom-phrase",
            "jfpc-vehicle-listings-visitor-recently-clicked",
            "jfpc-vehicle-listings-visitor-recently-clicked-make-model",
            "jfpc-vehicle-listings-visitor-recommended",
            "jfpc-vehicle-listings-visitor-saved",
            "jfpc-vehicle-listings-carfax-product-card",
            "jfpc-vehicle-listings-carfax",
            "jfpc-vehicle-vdp-redirect",
            "jfpc-template",
            "jfpc-pageview-event-beacon"
        ];

        let loaded = [];
        eligible.forEach(eligiblePublisherComponent => {
            loaded = loaded.concat(Array.prototype.slice.call(document.getElementsByTagName(eligiblePublisherComponent)));
        });

        let newlyLoaded = [];
        if(loaded.length > 0) {
            loaded.forEach(loadedPublisherComponent => {
                if(loadedPublisherComponent && loadedPublisherComponent.shadowRoot) {
                    let publisherComponentInner = loadedPublisherComponent.shadowRoot.querySelector(".jfpc");
                    if(publisherComponentInner) {
                        let localPublisherComponentIdentifier = this.getLocalPublisherComponentIdentifier(publisherComponentInner.getAttribute("publisher-component-id"), publisherComponentInner.getAttribute("publisher-component-placement"));
                        if(!this.publisherComponents.loaded.includes(localPublisherComponentIdentifier)) {
                            this.publisherComponents.loaded.push(localPublisherComponentIdentifier);
                            newlyLoaded.push(publisherComponentInner);
                        }
                    }
                }
            });
        }

        return newlyLoaded;
    },
    getLocalPublisherComponentIdentifier(publisherComponentId, publisherComponentPlacement) {
        return publisherComponentId + "_" + publisherComponentPlacement;
    },

    clearEventQueue() {
        if(!this.visitorId || !this.visitorSiteNavigationLogId) {
            return;
        }

        this.eventQueue = this.eventQueue.reduce((newQueue, currentEvent) => {
            // If the event contains component data, then only fire the event if its' component has been viewed.
            if(
                currentEvent.eventName !== "PageView"
                && currentEvent.eventData.publisher_component_id
                && currentEvent.eventData.publisher_component_placement
                && ![1,2,19,27,28,29,30,41,42,43].includes(currentEvent.eventData.publisher_component_id)
            ) {
                if(this.publisherComponents.viewed.includes(this.getLocalPublisherComponentIdentifier(currentEvent.eventData.publisher_component_id, currentEvent.eventData.publisher_component_placement))) {
                    this.track(currentEvent.eventName, currentEvent.eventData);
                } else {
                    newQueue.push(currentEvent);
                }
            } else {
                this.track(currentEvent.eventName, currentEvent.eventData);
            }

            return newQueue;
        }, []);
    },
    track(eventName, eventData) {
        if(!this.initialized || !this.token) {
            console.error("Pixel not initialized.");
        }

        if(!this.visitorId || !this.visitorSiteNavigationLogId) {
            this.eventQueue.push({eventName: eventName, eventData: eventData});
            return;
        }

        // Put all events containing "component" data into the queue, unless its corresponding component identifier is in the "viewed components"
        if(
            eventName !== "PageView"
            && eventName !== "NoContentLoaded"
            && eventData.publisher_component_id
            && eventData.publisher_component_placement
            && ![1,2,19,27,28,29,30].includes(eventData.publisher_component_id)
        ) {
            if(!this.publisherComponents.viewed.includes(this.getLocalPublisherComponentIdentifier(eventData.publisher_component_id, eventData.publisher_component_placement))) {
                this.eventQueue.push({eventName: eventName, eventData: eventData});
                return;
            }
        }

        eventData.visitor_id = this.visitorId;
        eventData.visitor_site_navigation_log_id = this.visitorSiteNavigationLogId;
        eventData.referer = window.location.href;

        // TODO: Add max number of same events per session rules.
        
        let formData = new FormData();
        formData.append("event_name", eventName);
        formData.append("event_data", JSON.stringify(eventData));
        (async ()=> await fetch("https://api-v2.jumpfeed.com/network/publisher/events/track", {
            method: "POST",
            headers: { 'Authorization': "Bearer " + this.token },
            body: formData,
            // mode: "no-cors",
            keepalive: eventName === "ContentClick"
        }))();
    },

    /* Component Tracking Helpers */
    isElementInViewport(el) {
        let rect = el.getBoundingClientRect();

        if (rect.width == 0 && rect.height == 0) return false;

        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },
    onElementInViewport(el, callback) {
        return () => {
            let visible = this.isElementInViewport(el);
            if (visible) {
                if (typeof callback == 'function') {
                    callback();
                }
            }
        }
    },

    /* Cookie Helpers */
    setCookie(name,value,days = 0) {
        let expires = "; expires=Tue, 19 Jan 2100 03:14:07 UTC;";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString() + ";";
        }
        document.cookie = name + "=" + (value || "")  + expires + " path=/; domain=." + window.location.hostname.split(".").slice(-2).join(".") + ";";
    },
    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(";");
        for (let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)===" ") c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    deleteCookie(name) {
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
};